import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { ComponentDataTable, DefaultModal, SimpleCenteredModal } from '../../components';

import {
  indexReliquidationProcessesRequest,
  deleteReliquidationProcessRequest,
  closeReliquidationProcessRequest,
  exportReliquidationProcessRequest,
  massiveDestroyReliquidationProcessRequest
} from '../../requests/reliquidationProcesses';
import { sendAlert } from '../../actions/utils';
import { downloadFile } from '../../services/utils';
import columns from './ColumnsReliquidations';
import massiveActions from '../RemunerationProcesses/AdvancePayments/Datatables/massiveActions';

const defaultModalState = {
  title: '',
  body: null,
  show: false
};

const ReliquidationProcessesDatatable = ({ moreData, setMoreData, customParams, setOnRequest, onRequest }) => {
  const [modalAction, setModalAction] = useState(() => null);
  const [modalBody, setModalBody] = useState('');
  const [modalItem, setModalItem] = useState({});
  const [amount, setAmount] = useState(0);
  const [modalShow, setModalShow] = useState(false);
  const [modalTitle, setModalTitle] = useState('');
  const [simpleModalState, setSimpleModalState] = useState(defaultModalState);
  const [selectedRows, setSelectedRows] = useState([]);
  const [clearSelectedRows, setClearSelectedRows] = useState(false);
  const [reliquidationProcesses, setReliquidationProcesses] = useState([]);
  const [selectedCount, setSelectedCount] = useState('');
  const history = useHistory();
  const dispatch = useDispatch();

  const handleSelectedRows = item => {
    setSelectedRows(item.selectedRows);
    setSelectedCount(item.selectedCount);
  };

  const handleRequest = async params => {
    setOnRequest(true);
    setClearSelectedRows(false);
    indexReliquidationProcessesRequest({
      dispatch,
      params: {
        ...customParams,
        ...params
      },
      successCallback: response => {
        setOnRequest(false);
        setReliquidationProcesses(response.data.data);
        setAmount(response?.data?.metadata?.amount);
      },
      callback: () => {
        setOnRequest(false);
        setClearSelectedRows(true);
      }
    });
  };

  const handleModalClose = () => {
    setModalShow(false);
  };

  const handleSuccess = message => {
    dispatch(sendAlert({ kind: 'success', message }));
    setMoreData(!moreData);
  };

  const removeReliquidationProcess = item => {
    setOnRequest(true);
    deleteReliquidationProcessRequest(item.id, {
      dispatch,
      successCallback: () => handleSuccess('Proceso de Reliquidación Eliminado Correctamente'),
      callback: () => {
        handleModalClose();
        setOnRequest(false);
      },
      service: 'payroll'
    });
  };

  const closeReliquidationProcess = item => {
    setOnRequest(true);
    closeReliquidationProcessRequest(item.id, {
      dispatch,
      successCallback: () => handleSuccess('Proceso Cerrado Correctamente'),
      callback: () => {
        handleModalClose();
        setOnRequest(false);
      }
    });
  };

  const massiveDestroy = () => {
    const payrollProcessIds = selectedRows.map(payroll => payroll.id);

    setOnRequest(true);
    setClearSelectedRows(false);
    massiveDestroyReliquidationProcessRequest({
      dispatch,
      params: {
        ids: payrollProcessIds
      },
      successCallback: () => handleSuccess('Procesos Eliminados Correctamente'),
      callback: () => {
        handleModalClose();
        setOnRequest(false);
        setClearSelectedRows(true);
        setMoreData(!moreData);
      }
    });
  };

  const handleFailureRequest = error => {
    dispatch(sendAlert({ kind: 'error', message: error.response?.data?.message }));
    setOnRequest(false);
  };

  const massiveExport = () => {
    const payrollProcessIds = selectedRows.map(payroll => payroll.id);
    setOnRequest(true);
    exportReliquidationProcessRequest({
      dispatch,
      params: {
        filter_by_ids: payrollProcessIds,
        ...customParams
      },
      successCallback: response => {
        setModalShow(false);
        downloadFile(response);
        setOnRequest(false);
      },
      failureCallback: handleFailureRequest
    });
  };

  const handleButtonClick = (item, action) => {
    switch (action) {
      case 'show':
        history.push({ pathname: `/reliquidation_processes/${item.id}/edit`, state: { item, onlyShow: true } });
        break;
      case 'edit':
        history.push({ pathname: `/reliquidation_processes/${item.id}/edit`, state: { item, onlyShow: false } });
        break;
      case 'destroy':
        setModalTitle('Eliminar Proceso de Reliquidación');
        setModalShow(true);
        setModalBody('¿Estás seguro que deseas eliminar este proceso de reliquidación?');
        setModalAction(() => removeReliquidationProcess);
        setModalItem(item);
        break;
      case 'close':
        setModalTitle('Cerrar Proceso de Reliquidación');
        setModalShow(true);
        setModalBody('¿Estás seguro que deseas cerrar este mes de proceso?');
        setModalAction(() => closeReliquidationProcess);
        setModalItem(item);
        break;
      default:
        // eslint-disable-next-line no-console
        console.warn('Error: Action not found');
    }
  };

  const handleClick = action => {
    switch (action) {
      case 'massive_deactivate':
        setModalTitle('Eliminar Procesos de Remuneración');
        setModalShow(true);
        setModalBody('¿Estás seguro que deseas eliminar los procesos seleccionados?');
        setModalAction(() => massiveDestroy);
        break;
      case 'massive_export':
        setModalTitle('Descargar Procesos de Remuneración');
        setModalShow(true);
        setModalBody('¿Estás seguro que deseas descargar los procesos seleccionados?');
        setModalAction(() => massiveExport);
        break;
      default:
        // eslint-disable-next-line no-console
        console.warn('Error: Action not found');
    }
  };

  return (
    <>
      <div className="data-table-yellow">
        <ComponentDataTable
          onRequest={onRequest}
          resourceRequest={handleRequest}
          columns={columns(handleButtonClick)}
          data={reliquidationProcesses}
          totalRows={amount}
          moreData={moreData}
          selectableRows
          selectedRowCount={selectedRows.selectedCount}
          clearSelectedRows={clearSelectedRows}
          onSelectedRowsChange={handleSelectedRows}
          withMassActions
          massActions={massiveActions(handleClick, true, !selectedCount)}
        />
        <DefaultModal
          title={modalTitle}
          body={modalBody}
          show={modalShow}
          handleClose={() => handleModalClose}
          handleConfirm={() => modalAction(modalItem)}
          disabled={onRequest}
          variantBtnClose="outline-info"
          variantBtnSave="primary"
        />
        <SimpleCenteredModal
          title={simpleModalState.title}
          size="md"
          body={simpleModalState.body}
          show={simpleModalState.show}
          onHide={() => setSimpleModalState(state => ({ ...state, show: false }))}
        />
      </div>
    </>
  );
};

export default ReliquidationProcessesDatatable;
